import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL, PRICE, REFERENCE_PRICE } from "../data/site";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const update = () => {
      const anchor = document.getElementById("first-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    update();
    window.addEventListener("scroll", update, {
      passive: true
    });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);
  return <AnimatePresence data-id="element-35" data-mp="boyd8vhykabr">
      {visible && <motion.div initial={{
      y: 110,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 110,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:inset-x-auto sm:bottom-6 sm:right-6 sm:px-0 sm:pb-0" data-id="element-36" data-mp="196ge13zmkxsq">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-3 rounded-2xl border-2 border-gold bg-cta px-5 py-4 text-white shadow-[0_12px_32px_-6px_rgba(10,27,63,0.55)] transition-colors duration-150 ease-out hover:bg-cta-dark focus-visible:outline focus-visible:outline-4 focus-visible:outline-gold sm:w-auto sm:px-7" data-id="element-37" data-mp="21d5p6to3c6jy">
            <span className="text-base font-extrabold uppercase tracking-wide sm:text-lg" data-id="element-38" data-mp="1ieb99hcw5027">Get the Blueprint™</span>
            <span className="flex items-baseline gap-1.5" data-id="element-39" data-mp="1nc33wj4x70a3">
              <span className="text-sm text-cta-soft line-through" data-id="element-40" data-mp="3crt0pfgf2h2i">{REFERENCE_PRICE}</span>
              <span className="text-xl font-extrabold text-gold" data-id="element-41" data-mp="3cpyezyxbmkxd">{PRICE}</span>
            </span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-42" data-mp="3hojflzghj6mc" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}